import axios from "axios";
import { baseUrl } from "./constants";

const getImageUrl = (query) => {
   return axios.get(
    `${baseUrl}/supportingArticles/getPresignedPathForSupportingArticleUpload?${query}`,
    {
      params: query,
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export default {
  //   loginApi,
  getImageUrl,
};
